









































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    CommonModalHeader,
    AccountIcon
  },
})
export default class MemberDetailModal extends Vue {
  @Prop(Boolean) public isOpenMemberDetailModal!: boolean;
  private modalHeaderTitle = 'メンバー情報詳細';
  private modalMode = 'add';
  private isOpenMemberDetailModalEmit = this.isOpenMemberDetailModal;

  @Emit('closeMemberDetailModal')
  private closeMemberDetailModal(): void {
    this.isOpenMemberDetailModalEmit = false;
  }
}
